import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBouvetIsland = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1643_5782)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1643_5782",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: -4,
			y: 0,
			width: 27,
			height: 20,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M-4 0H23V20H-4V0Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_1643_5782)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M-5.18124 0H24.3374V21.3333H-5.18124V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M-6.23593 -3.24164H2.99047V8.2667H-6.23593V-3.24164ZM8.20907 -0.0249712H24.2825V8.2667H8.20907V-0.0249712ZM-5.16437 13.3334H2.86813V21.2625H-5.16437V13.3334ZM8.31876 13.4209H24.2783V21.2625H8.31876V13.4209Z",
					fill: "#D72828"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M4.29829 -1.05829H7.01095V21.2625H4.28986L4.29829 -1.05829Z",
					fill: "#003897"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M-5.16437 9.3667H24.2825V12.0125H-5.16437V9.3667Z",
					fill: "#003897"
				})
			]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1643_5782",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 10,
			fill: "white"
		})
	}) })]
});
export default SvgBouvetIsland;
